import React, { useState } from 'react'

import { Box, Button, Card, CardContent, CardHeader, Grid } from '@mui/material'
import { Link, useParams } from 'react-router-dom'
import { UrlProvider } from 'urls'

import { Badge } from 'components/_base'
import LoadingView from 'components/LoadingView'
import { UserCustomers, UserDetails } from 'components/user'
import UserDeleteConfirm from 'components/user/UserDeleteConfirm'
import { useUser } from 'hooks/useUser'

const User = () => {
  const { id } = useParams()
  const { data: user, isLoading, error } = useUser(id)
  const [deleteOpen, setDeleteOpen] = useState(false)

  const renderName = () => {
    const { deleted_at, first_name, last_name } = user || {}

    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box component="span" sx={{ mr: '1rem' }}>
          {first_name || last_name ? [first_name, last_name].join(' ') : ''}
        </Box>
        {deleted_at && <Badge color="red" text="Deleted" />}
      </Box>
    )
  }

  const renderActions = () => (
    <>
      <Link to={UrlProvider.getUrl('user.edit', { id })}>
        <Button>Edit</Button>
      </Link>
      <Button color="secondary" onClick={() => setDeleteOpen(true)}>
        Delete
      </Button>
    </>
  )

  return (
    <Card>
      <LoadingView error={error ? 'Error occurred when loading user data' : ''} loading={isLoading}>
        <CardHeader action={renderActions()} title={renderName()} />

        <CardContent>
          <Grid container spacing={2}>
            <Grid
              size={{
                sm: 4,
              }}>
              <UserDetails data={user} />
            </Grid>

            <Grid
              size={{
                sm: 8,
              }}>
              <UserCustomers customers={user?.customers} />
            </Grid>
          </Grid>
        </CardContent>
      </LoadingView>
      <UserDeleteConfirm id={id} onClose={() => setDeleteOpen(false)} open={deleteOpen} />
    </Card>
  )
}

export default User
